// src/js/main.js

import '../css/tailwind.css';
import '../scss/main.scss';

// Це змушує Vite побачити всі зображення, обробити їх (imagemin) 
// та покласти в dist/img згідно з правилами assetFileNames
import.meta.glob('../img/**/*', { eager: true });

import { domReady, waitForIdle } from "./functions/utility.js";

/**
 * Кешування селекторів для перевірки наявності елементів на сторінці
 * =========================================================================
 */

const isBackend = document.body.classList.contains('wp-admin');

const mainmenu = document.querySelector("#mainmenu");

// Модулі
const counters = document.querySelector('.counters') !== null;
const aos = document.querySelector('[data-aos]') !== null;
const choicesElements = document.querySelector(".js-choice") !== null;
const accordion = document.querySelector(".acc-container") !== null;
const swiper = document.querySelector(".swiper") !== null;
const flipCards = document.querySelector('[data-js="flip-card"]') !== null;
const citation = document.querySelector('.citation-btn') !== null;
const horizontalAcc = document.querySelector('.horizontal-accordion-container') !== null;
//const pdfViewer = document.querySelector('.pdf-viewer-wrapper') !== null;

// ACF Блоки
//const hasHero = document.querySelector(".v-hero");

// =========================================================================
// CRITICAL: Load immediately (blocking)
// =========================================================================
const criticalImports = [];

criticalImports.push(import("./modules/base.js").then((m) => m.init()));

if (criticalImports.length) Promise.all(criticalImports).catch(console.error);


// =========================================================================
// HIGH PRIORITY: Load after DOM ready
// =========================================================================
domReady().then(() => {
  const imports = [];

  if (aos) {
    imports.push(import("./modules/aos.js").then((m) => m.init()));
  }

  if (mainmenu) {
    imports.push(import("./modules/mainmenu.js").then((m) => m.init()));
  }
  if (swiper) {
    imports.push(import("./modules/swiper.js").then((m) => m.init()));
  }
  /*if (pdfViewer) {
      imports.push(import("./modules/pdf-viewer.js").then((m) => m.init()));
  }*/
  //Блоки, що видно на першому екрані
  /*if (hasHero) {
  imports.push(import("../../blocks/hero/script.js").then((m) => m.init()));
  }*/

  if (imports.length) Promise.all(imports).catch(console.error);
});

// =========================================================================
// LOW PRIORITY: Load when browser is idle
// =========================================================================
waitForIdle().then(() => {
  const imports = [];

  // 1. Модулі (завантажуються з папки modules)

  if (counters || isBackend) {
    imports.push(import("./modules/counters.js").then((m) => m.init()));
  }

  if (choicesElements) {
    imports.push(import("./modules/choices.js").then((m) => m.init()));
  }
  if (accordion || isBackend) {
    imports.push(import("./modules/accordion.js").then((m) => m.init()));
  }
  if (flipCards || isBackend) {
    imports.push(import("./modules/flip-cards.js").then((m) => m.init()));
  }
  if (citation || isBackend) {
    imports.push(import("./modules/citation.js").then((m) => m.init()));
  }

  if (horizontalAcc || isBackend) {
    imports.push(import("./modules/horizontal-accordion.js").then((m) => m.init()));
  }

  /*if (hasCustomModal) {
      imports.push(import("./modules/modal.js").then((m) => m.init()));
  }*/

  // 2. ACF Блоки (завантажуються зі своїх папок у src/blocks)

  /*if (hasAboutUs) {
      imports.push(import("../../blocks/about-us/script.js").then((m) => m.init()));
  }*/


  if (imports.length) Promise.all(imports).catch(console.error);
});